import React from 'react';
import PropTypes from 'prop-types';
import { Paper, PaperTitle } from 'virtues-bootstrap';
import { withTranslation } from 'react-i18next';
import { map } from 'ramda';
import ResourceGroupItem from 'components/ui/ResourceGroupItem';
import ResourceItem from 'components/ui/ResourceItem';
import s from '../styles.module.scss';

const Sidebar = ({ dataList, faqDataList, openFaq, groupId, t }) => (
  <Paper>
    <PaperTitle withBorder>{t('resources.resources')}</PaperTitle>

    {dataList &&
      map(({ groupUrl, title, list }) => (
        <ResourceGroupItem
          className={s.mediaItem}
          active={groupId === groupUrl}
          key={groupUrl}
          url={groupUrl}
          title={t(title)}
        >
          {map(
            article => (
              <ResourceItem
                className={s.mediaItem}
                read={article.read}
                url={`${groupUrl}/${article.id}`}
                key={article.id}
              >
                {article.title}
              </ResourceItem>
            ),
            list,
          )}
        </ResourceGroupItem>
      ))(dataList)}

    <ResourceGroupItem
      className={s.mediaItem}
      url="faq"
      active={openFaq}
      title={t('resources.faq')}
    >
      {faqDataList &&
        map(({ subGroupUrl, subGroup, list }) => (
          <ResourceGroupItem
            className={s.mediaItem}
            url={`faq/${subGroupUrl}`}
            active={groupId === subGroupUrl}
            subGroup
            key={subGroup}
            title={subGroup}
            closeUrl="faq"
          >
            {map(
              ({ title, id, read }) => (
                <ResourceItem
                  className={s.mediaItem}
                  read={read}
                  subField
                  url={`faq/${subGroupUrl}/${id}`}
                  key={id}
                >
                  {title}
                </ResourceItem>
              ),
              list,
            )}
          </ResourceGroupItem>
        ))(faqDataList)}
    </ResourceGroupItem>
  </Paper>
);

Sidebar.defaultProps = {
  groupId: undefined,
  dataList: null,
  faqDataList: null,
};

Sidebar.propTypes = {
  t: PropTypes.func.isRequired,
  faqDataList: PropTypes.arrayOf(
    PropTypes.shape({
      subGroup: PropTypes.string.isRequired,
      subGroupUrl: PropTypes.string.isRequired,
      list: PropTypes.arrayOf(
        PropTypes.shape({
          read: PropTypes.bool.isRequired,
          title: PropTypes.string.isRequired,
          id: PropTypes.string,
        }),
      ),
    }),
  ),
  dataList: PropTypes.arrayOf(
    PropTypes.shape({
      groupUrl: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      list: PropTypes.arrayOf(
        PropTypes.shape({
          read: PropTypes.bool.isRequired,
          title: PropTypes.string.isRequired,
          type: PropTypes.string.isRequired,
          id: PropTypes.string.isRequired,
        }),
      ),
    }),
  ),
  openFaq: PropTypes.bool.isRequired,
  groupId: PropTypes.string,
};

export default withTranslation()(Sidebar);
